import PrismicClient from '@prismicio/client';
import * as PrismicHelpers from '@prismicio/helpers';

import defaults from './PrismicAdapter.config.json';

export default (function (){

    function getData(options) {
        return new PrismicAdapter(options);
    }

    /************************************/
    /******//* !Prismic Adapter *//******/
    /************************************/

    const PrismicAdapter = function(options) {

        if (typeof options !== "object") {
            options = {};
        }

        if (typeof options.callback !== "function") {
            options.callback = function() { console.warn("prismicAdapter: No callback defined."); };
        }

            // Settings

        if (typeof options.settings !== "object") {
            options.settings = {};
        }

        this.settings = Object.assign({}, defaults, options.settings);

            // Get data

        const data = {
            uid: null,
            batchCount: null,
            currentIndex: null,
            pagination: {},
        };

        if (typeof options.data === "object") {
            this.data = Object.assign({}, data, options.data);
        }

        if (typeof uid === "string") {
            this.data.uid = uid;
        }

        if (typeof this.settings.batchCount === "number") {
            this.data.batchCount = this.settings.batchCount;
            this.data.currentIndex = this.data.batchCount;
        }

        this.settings = Object.assign({}, defaults, options.settings);
        this.settings.endpoint = `https://${this.settings.repositoryName}.cdn.prismic.io/api/v2`;

        this.customType = options.settings.customType;

        this.prismicClient = PrismicClient.client(this.settings.endpoint);

        this.getData((data) => {
            options.callback(data)
        });

    }

    PrismicAdapter.prototype.getData = function(callback) {

        if (typeof callback !== "function") {
            callback = () => { console.warn("PrismicAdapter: No callback defined!"); }
        }

        if (this.data.uid) {

            this.prismicClient.getByUID(this.customType, this.data.uid, {},
                (error, response) => {

                    if (error) {
                        console.error("PrismicAdapter: Something went wrong.", error);
                        callback({});
                        return;
                    }

                    const item = this.getItem(response);

                    const data = {
                        item: item,
                    }

                    this.data = Object.assign({}, this.data, data);

                    // FIXME: Using method "getByType()" with params "orderings" and after" of Prismic client in version 7

                    if (typeof item.type === "string" && item.type === "blog-story") {
                        // Only get siblings if type is "Fortschritt"

                        const getPrevSibling = async () => {

                            const entry = await this.getSibling(data.item.id, {
                                direction: "prev",
                            });

                            this.data.pagination.prev = this.getItem(entry);

                            getNextSibling();
                        }

                        const getNextSibling = async () => {

                            const entry = await this.getSibling(data.item.id, {
                                direction: "next",
                            });

                            this.data.pagination.next = this.getItem(entry);

                            callback(this.data);

                        }

                        getPrevSibling();

                    } else {
                        callback(this.data);
                    }

                }
            );

        } else {

            this.prismicClient.query(
                PrismicClient.Predicates.at('document.type', this.customType),
                {
                    orderings : `[my.${this.customType}.date desc]`,
                    pageSize : '100',
                },
                (error, response) => {

                    if (error) {
                        console.error("PrismicAdapter: Something went wrong.", error);
                        return;
                    }

                    if (response.next_page) {
                        console.warn("PrismicAdapter: Limit exceeded!");
                    }

                    const data = {
                        items: this.getItems(response.results)
                    }

                    data.items.sort((item) => {
                        return item.type === "Ankündigung" ? -1 : 0;
                    });

                    this.data = Object.assign(this.data, data);

                    callback(this.data);
                }
            );

        }

        return;

    }

    PrismicAdapter.prototype.getSibling = function(id, options) {

        return new Promise((resolve) => {

            let entry = {};

            if (typeof options !== "object") {
                options = {};
            }

            if (typeof id !== "string" || id === "") {
                resolve(entry);
            }

            let order = "";

            if (options.direction && options.direction === "prev") {
                order = "desc";
            }

            this.prismicClient.query(
                PrismicClient.Predicates.at('document.type', this.customType),
                {
                    after: id,
                    orderings : `[my.${this.customType}.date ${order}]`,
                    pageSize : '1',
                },
                (error, response) => {

                    if (Array.isArray(response.results) && response.results.length !== 0) {
                        entry = response.results[0];
                    }

                    resolve(entry);

                }
            );

        });

    }

    PrismicAdapter.prototype.getItems = function(datasets) {

        const items = [];

        const dateFormat = {
            year: 'numeric', month: 'long'
        };

            // If datasets is a single object convert it to an array

        if (typeof datasets === "object" && datasets.constructor !== Array) {
            const dataset = datasets;

            datasets = [];
            datasets.push(dataset);
        }

        for (let i = 0; i < datasets.length; i++) {

            const item = this.getItem(datasets[i]);

            items.push(item);

        }

        return items;

    }

    PrismicAdapter.prototype.getItem = function(dataset) {

        if (typeof dataset !== "object" || Object.keys(dataset).length === 0) {
            return {};
        }

        const dateFormat = {
            year: 'numeric', month: 'long'
        };

        const data = dataset.data;

        // Get type

        let type = "";

        if (typeof data.type === "string" && data.type !== "Standard"){
            type = data.type;
        }

        // Format date

        let date = "",
            day = "",
            month = "";

        if (typeof data.date === "string"){
            const event = new Date(data.date);
            date = event.toLocaleDateString('de-DE', dateFormat);

            month =  event.toLocaleDateString('de-DE', { month: 'short' });
            day = event.toLocaleDateString('de-DE', { day: '2-digit' });
        }

        // Get url

        if (this.settings.root !== "" && ! this.settings.root.match(/\/$/)) {
            this.settings.root += "/";
        }

        let teaserImage = this.getTeaser(data.teaser);

        if (typeof data.teaser.Teaser === "object" && typeof data.teaser.Teaser.url === "string") {
            teaserImage.src = data.teaser.Teaser.url;
        }

        const item = {
            id: dataset.id,
            url: this.settings.root + dataset.uid,
            type: type,
            date: date,
            day: day,
            month: month,
            images: {
                teaser: teaserImage,
                cover: this.getCover(data.teaser),
                photos: this.getPhotos(data),
            },
            videos: this.getVideos(data),
            data: this.getProjectData(data),
            title: PrismicHelpers.asText(data.title),
            description: PrismicHelpers.asText(data.description),
            richtextblocks: this.richtextBlocks(data),
        }

        //console.log(dataset, data);
        //console.log(item);

        return item;

    }

    PrismicAdapter.prototype.getTeaser = function(data) {

        const image = this.formatImage(data, {
            width: 580
        });

        return image;

    }

    PrismicAdapter.prototype.getCover = function(data) {

        const image = this.formatImage(data);

        return image;

    }

    PrismicAdapter.prototype.getProjectData = function(data) {

        const projectData = [];

        if (typeof data.body === "undefined" && typeof data.body.length === "undefined") {
            return richtextBlocks;
        }

        for (let i = 0; i < data.body.length; i++) {

            const dataset = data.body[i];

            if (typeof dataset.slice_type !== "string") {
                continue;
            }

            if (dataset.slice_type !== "data") {
                continue;
            }

            if (typeof dataset.items === "undefined" || typeof dataset.items.length === "undefined") {
                continue;
            }

            for (let j = 0; j < dataset.items.length; j++) {

                const item = dataset.items[j];

                if (typeof item !== "object" || typeof item["data-label"] !== "object" || typeof item["data-content"] !== "object") {
                    continue;
                }

                const entry = {
                    label: PrismicHelpers.asText(item["data-label"]),
                    description: PrismicHelpers.asHTML(item["data-content"]),
                };

                projectData.push(entry);

            }

        }

        return projectData;

    }

    PrismicAdapter.prototype.richtextBlocks = function(data) {

        const richtextBlocks = [];

        if (typeof data.body === "undefined" && typeof data.body.length === "undefined") {
            return richtextBlocks;
        }

        for (let i = 0; i < data.body.length; i++) {

            const dataset = data.body[i];

            if (typeof dataset.slice_type !== "string") {
                continue;
            }

            if (dataset.slice_type !== "textblock") {
                continue;
            }

            if (typeof dataset.primary !== "object" || typeof dataset.primary["richtext-block"] !== "object" || typeof dataset.primary["richtext-block"].length === "undefined") {
                continue;
            }

            const content = PrismicHelpers.asHTML(dataset.primary["richtext-block"]);

            richtextBlocks.push(content);

        }

        return richtextBlocks;

    }

    PrismicAdapter.prototype.getPhotos = function(data) {

        const photos = [];

        if (typeof data.body === "undefined" && typeof data.body.length === "undefined") {
            return photos;
        }

        for (let i = 0; i < data.body.length; i++) {

            const dataset = data.body[i];

            if (typeof dataset.slice_type !== "string") {
                continue;
            }

            if (dataset.slice_type !== "photowall") {
                continue;
            }

            if (typeof dataset.items === "undefined" || typeof dataset.items.length === "undefined") {
                continue;
            }

            for (let j = 0; j < dataset.items.length; j++) {

                const item = dataset.items[j];

                if (typeof item !== "object" || typeof item["photowall-image"] !== "object") {
                    continue;
                }

                const image = this.formatImage(item["photowall-image"]);

                    // Add image to photos

                photos.push(image);

            }

        }

        return photos;

    }

    PrismicAdapter.prototype.formatImage = function(data, options) {

        if (typeof data !== "object") {
            data = {};
        }

        if (typeof options !== "object") {
            options = {};
        }

        let image = Object.assign({}, data);

        if (typeof image.url === "string") {
            image.src = image.url;
            delete image.url;
        }

        if (typeof options.width === "number" || typeof options.height === "number") {

            let queryString = [];

            if (options.width) {
                queryString.push(`w=${options.width}`);
            }

            if (options.height) {
                queryString.push(`h=${options.height}`);
            }

            const location = document.createElement("a");
            location.href = image.src;

            let search = location.search.replace(/^\?/, "");

            search.split(/&/).forEach((parameter) => {

                const [key, value] = parameter.split(/=/);

                if (["rect", "w", "h"].includes(key)) {
                    return;
                }

                queryString.push(`${key}=${value}`);

            });

            image.src = location.origin + "/" + location.pathname + "?" + queryString.join("&");

        }

        image.orientation = this.getOrientation(image.dimensions);

        return image;

    }

    PrismicAdapter.prototype.getOrientation = function(dimensions) {

        let orientation = "";

        if (typeof dimensions !== "object" || typeof dimensions.width !== "number" || typeof dimensions.height !== "number" || dimensions.width === dimensions.height) {
            return orientation;
        }

        orientation = (dimensions.width > dimensions.height) ? "landscape" : "upright";

        return orientation;

    }

    PrismicAdapter.prototype.getVideos = function(data) {

        const videos = [];

        if (typeof data.body === "undefined" && typeof data.body.length === "undefined") {
            return videos;
        }

        for (let i = 0; i < data.body.length; i++) {

            const dataset = data.body[i];

            if (typeof dataset.slice_type !== "string" || dataset.slice_type !== "video") {
                continue;
            }

            if (typeof dataset.primary !== "object" || typeof dataset.primary["youtube-id"] !== "string" ) {
                continue;
            }

            videos.push({
                id: dataset.primary["youtube-id"],
            });

        }

        return videos;

    }

    return {
        getData: getData
    }

})();
